module.exports = __webpack_public_path__ + "img/yz_newMonth_yhq.28927fd7.png";